import { GraphSchema } from '@camelot/server';

export interface TenantInformation {
  id: string;
  tenantId: number;
  tenantName: string;
  tenantPersonId: number;
}

export const tenantInformationsProps = new GraphSchema<TenantInformation>(['tenantPersonId', 'tenantId', 'tenantName']);
